export enum NewsCategoryEnum {
  TIPS = 'Tips',
  WOUW_ACTUA = '@WouwActua',
  PROBLEEM_VAN_DE_WEEK = 'Probleem van de week',
  AANKONDIGING = 'Aankondiging',
  RELEASE_NOTE = 'Release note',
}

export const ANNOUNCEMENT_CATEGORIES: string[] = [NewsCategoryEnum.AANKONDIGING, NewsCategoryEnum.RELEASE_NOTE];

// Pseudo category for the news feed filters: it holds the news of every category at once.
// The negative id can never collide with a real category id.
export const ALL_NEWS_CATEGORY_ID = -1;

export interface NewsCategoryInterface {
  id?: number;
  label?: string;
  icon?: string;
  displayOrder?: number;
  isDefault?: boolean;
  showMethodIcon?: boolean;
}

export const ALL_NEWS_CATEGORY: NewsCategoryInterface = {
  id: ALL_NEWS_CATEGORY_ID,
  label: 'Alle',
};
